import React from 'react';

import { LayoutColors } from '@src/core/theme';
import { BodyRegularSemiBold } from '@src/fonts/typography/Typography';
import useTranslate from '@src/i18n/useTranslate';
import styled from 'styled-components';
import { Tooltip } from '@src/components/reusable/Tooltip';

interface RescheduleButtonProps {
  disabled: boolean;
  onClick: () => void;
  isPackageItem?: boolean;
}

const RescheduleButton = (props: RescheduleButtonProps) => {
  const { disabled, onClick, isPackageItem = false } = props;

  const { i18n } = useTranslate();

  return (
    <Tooltip arrow placement='top' showContent={isPackageItem} label={i18n('account_sale_reschedule_tooltip')}>
      <Button disabled={disabled} onClick={onClick}>
        {i18n('account_sale_reschedule')}
      </Button>
    </Tooltip>
  );
};

const Button = styled.button`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;

  ${BodyRegularSemiBold};
  color: ${LayoutColors.justBlue};
  background: transparent;
  border: 1px solid ${LayoutColors.justBlue};
  border-radius: 4px;
  padding: 8px 16px !important;
  cursor: pointer;
  transition: all 0.2s linear;

  &:hover {
    background: ${LayoutColors.justBlue};
    color: ${LayoutColors.whiteLight};
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }

  &:disabled:hover {
    background: transparent;
    color: ${LayoutColors.justBlue};
  }
`;

export default RescheduleButton;
